import { render, staticRenderFns } from "./SSRTable.vue?vue&type=template&id=9bc049f6&scoped=true&"
import script from "./SSRTable.vue?vue&type=script&lang=js&"
export * from "./SSRTable.vue?vue&type=script&lang=js&"
import style0 from "./SSRTable.vue?vue&type=style&index=0&id=9bc049f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc049f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})
